@if (savedPartListsError()) {
  <ideal-error [error]="savedPartListsError()"></ideal-error>
} @else {
  <div withLoadingSkeleton [isLoading]="savedPartListsLoading()">
    @let lists = savedPartLists();
    @if (lists.length) {
      <mat-nav-list>
        @for (partList of lists; track $index) {
          <a [routerLink]="[partList.listType, partList.id]">
            <mat-list-item>
              <span>
                {{ partList.name }}
              </span>
              <button
                type="button"
                mat-icon-button
                matListItemMeta
                (click)="$event.stopPropagation(); $event.preventDefault(); deletePartList(partList)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </mat-list-item>
          </a>
        }
      </mat-nav-list>
    } @else {
      <ideal-note>You don't have any saved part lists</ideal-note>
    }
  </div>
}
